export default function ThreadIconDetailed({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="15.5"
        fill="url(#paint0_linear_435:1119)"
      />
      <line
        x1="8.875"
        y1="2"
        x2="8.875"
        y2="30"
        stroke="white"
        stroke-opacity="0.25"
        strokeWidth="0.25"
      />
      <line
        x1="23.125"
        y1="2"
        x2="23.125"
        y2="30"
        stroke="white"
        stroke-opacity="0.25"
        strokeWidth="0.25"
      />
      <line
        x1="2"
        y1="7.875"
        x2="30"
        y2="7.875"
        stroke="white"
        stroke-opacity="0.25"
        strokeWidth="0.25"
      />
      <line
        x1="2"
        y1="24.125"
        x2="30"
        y2="24.125"
        stroke="white"
        stroke-opacity="0.25"
        strokeWidth="0.25"
      />
      <path
        d="M8.75 10.75C8.75 9.64543 9.64543 8.75 10.75 8.75H21.25C22.3546 8.75 23.25 9.64543 23.25 10.75V21.25C23.25 22.3546 22.3546 23.25 21.25 23.25H10.75C9.64543 23.25 8.75 22.3546 8.75 21.25V10.75Z"
        fill="url(#paint1_linear_435:1119)"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 16H9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="white" />
      <defs>
        <linearGradient
          id="paint0_linear_435:1119"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#60A5FA" />
          <stop offset="1" stopColor="#C084FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_435:1119"
          x1="16"
          y1="8.75"
          x2="16"
          y2="23.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.69" />
          <stop offset="1" stopColor="white" stopOpacity="0.26" />
        </linearGradient>
      </defs>
    </svg>
  );
}
